/** @format */

import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '@material-ui/core/Icon';
import Face from '@material-ui/icons/Face';
import GridContainer from '../../components/Grid/GridContainer.jsx';
import GridItem from '../../components/Grid/GridItem.jsx';
import CustomInput from '../../components/CustomInput/CustomInputExt';
import CustomInputPassword from '../../components/CustomInput/CustomInputPassword';
import Button from '../../components/CustomButtons/ButtonExt';
import Card from '../../components/Card/Card.jsx';
import CardBody from '../../components/Card/CardBody.jsx';
import CardHeader from '../../components/Heading/CardHeaderExt';
import CardFooter from '../../components/Card/CardFooter.jsx';
import I18n from '../../components/Translate/I18n';
import { authApiActions } from '../../modules/auth/actions';
import { AuthReducersType } from '../../modules/auth/reducer';
import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import i18n from 'i18next';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import LanguageSelect from '../../components/Translate/LanguageSelect';

const LoginPage = (props: { classes: any }): React.ReactElement => {
    const { classes } = props;
    const dispatch = useDispatch();
    const { loginError, loginErrorMessage } = useSelector((state: { auth: AuthReducersType }) => state.auth, shallowEqual);
    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [cardHidden, setCardHidden] = useState<boolean>(true);
    const { enqueueSnackbar } = useSnackbar();

    const handleSubmit = (): void => {
        if (!username || !password) {
            return;
        }

        dispatch(authApiActions.login(username, password));
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const { name, value } = e.target;
        if (name === 'username') {
            setUsername(value);
        }
        if (name === 'password') {
            setPassword(value);
        }
    };

    useEffect(() => {
        setTimeout(() => {
            setCardHidden(false);
        }, 700);
    }, []);

    useEffect(() => {
        if (loginError) {
            let msg = i18n.t('translation:login_page.invalid_credentials');
            if (loginErrorMessage) {
                msg = i18n.t('translation:login_page.' + loginErrorMessage);

                if (loginErrorMessage.toLowerCase() === 'Access Denied'.toLowerCase()) {
                    msg = i18n.t('translation:login_page.invalid_credentials');
                }
            }
            enqueueSnackbar(msg, { variant: 'error', autoHideDuration: 4000 });
        }
    }, [loginError, enqueueSnackbar, loginErrorMessage]);

    useEffect(() => {
        //Try kerberos login
        dispatch(authApiActions.loginKerberos());
    }, [dispatch]);

    return (
        <div className={classes.loginPageContainer}>
            <GridContainer justify="center">
                <GridItem xs={12} sm={6} md={4}>
                    <Card login className={cardHidden ? classes['cardHidden'] : ''}>
                        <CardHeader className={classes.textCenter} trans={'translation:login_page.' + process.env.REACT_APP_PANEL_NAME} />
                        <CardBody>
                            <CustomInput
                                labelText="translation:login_page.username"
                                id="username"
                                name="username"
                                formControlProps={{ fullWidth: true }}
                                onChange={handleChange}
                                inputProps={{
                                    value: username,
                                    // endAdornment: (
                                    //     <InputAdornment position="end">
                                    //         <Face className={classes.inputAdornmentIcon} />
                                    //     </InputAdornment>
                                    // ),
                                }}
                            />
                            <CustomInputPassword
                                labelText="translation:login_page.password"
                                id="password"
                                type="password"
                                name="password"
                                onChange={handleChange}
                                formControlProps={{ fullWidth: true }}
                                inputProps={
                                    {
                                        // endAdornment: (
                                        //     <InputAdornment position="end">
                                        //         <Icon className={classes.inputAdornmentIcon}>lock_outline</Icon>
                                        //     </InputAdornment>
                                        // ),
                                    }
                                }
                            />
                        </CardBody>
                        <CardFooter className={classes.justifyContentCenter}>
                            <CustomTextButtom
                                size={'lg'}
                                color={'primary'}
                                callback={handleSubmit}
                                callbackParam={{}}
                                label={'translation:login_page.login'}
                            />
                        </CardFooter>
                        <CardFooter className={classes.justifyContentCenter}>
                            <LanguageSelect />
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
};

export default withStyles(oplAppStyle)(LoginPage);
